module.exports = __webpack_public_path__ + "img/type2.84c00cfb.png";